// Vendor imports
const { connect } = require('react-redux')
// Lib imports
const businessEvents = require('client/lib/business-events')
// Container imports
const UserProfileLayout = require('./component-dumb')
const selectors = require('./into-item-card-selectors')

function mapStateToProps(state) {
  return {
    items: selectors.getItemCards(state.feed.items),
    user: state.profileUser
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onPaginate: function () {
      dispatch(async function (dispatch, getState) {
        const { nextUrl } = getState().feed.meta
        const pageNumber = nextUrl.split('/').pop()
        await businessEvents.trackSegment('into-user-profile-scroll', {
          pageNumber
        })
      })
    }
  }
}

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  UserProfileLayout
)

module.exports = SmartComponent
